var parent = require('../../actual/promise');
require('../../modules/esnext.aggregate-error');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.promise.all-settled');
require('../../modules/esnext.promise.try');
require('../../modules/esnext.promise.any');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/full/promise/index.js
// module id = 360
// module chunks = 2